import React from 'react';

import { formatMadrid } from '../../../utils/radioTime';
import { multilangLabel } from './RadioFields';

/*
The Programs and Episodes lists, for the shared DataTable. Dates are shown in Madrid
time. Sorting is server-side; the sortable columns are the fields getRadioShowsList is
expected to whitelist (id, slug, firstAirDate, updatedAt); an unknown one falls back to
the list's default order on the backend.
*/

const statusBadge = status => (
  <span className={`radio-badge${status === 'oculta' ? ' is-hidden' : ''}`}>{status === 'oculta' ? 'Hidden' : 'Visible'}</span>
);

const titleCell = row => (
  <span>
    {multilangLabel(row.title, '(no title)')}
    {row.highlight ? <span className="radio-badge" style={{ marginLeft: 6 }}>Highlight</span> : null}
  </span>
);

const editColumn = onEdit => ({
  field: null,
  headerName: '',
  type: 'action',
  align: 'left',
  content: row => (
    <button
      type="button"
      className="font-icon icon-edit text-20 cursor-pointer bg-transparent border-0 p-0"
      title="Edit"
      aria-label={`Edit show ${row.id} (${row.slug})`}
      onClick={() => onEdit(row.id)}
    />
  ),
});

const deleteColumn = onDelete => ({
  field: null,
  headerName: ' ',
  type: 'action',
  align: 'right',
  content: row => (
    <button
      type="button"
      className="font-icon icon-trash text-20 cursor-pointer bg-transparent border-0 p-0"
      title="Delete"
      aria-label={`Delete show ${row.id} (${row.slug})`}
      onClick={() => onDelete(row)}
    />
  ),
});

const dateColumn = (field, headerName, { sortable = false, description } = {}) => ({
  field,
  headerName,
  type: 'action',
  align: 'left',
  sortable,
  description,
  content: row => formatMadrid(row[field]) || '—',
});

export const programColumns = ({ onEdit, onDelete, onShowEpisodes }) => [
  { field: 'id', headerName: 'id', type: 'string', isId: true, sortable: true, align: 'left' },
  editColumn(onEdit),
  {
    field: 'title', headerName: 'title (es)', type: 'action', align: 'left', content: titleCell,
  },
  { field: 'slug', headerName: 'slug', type: 'string', sortable: true, align: 'left' },
  {
    field: 'status', headerName: 'status', type: 'action', align: 'left', content: row => statusBadge(row.status),
  },
  { field: 'channel', headerName: 'channel', type: 'string', align: 'left' },
  {
    field: 'episodeCount',
    headerName: 'episodes',
    type: 'action',
    align: 'right',
    description: 'Non-deleted episodes. Click to list them.',
    content: row => (
      <button type="button" className="radio-link" onClick={() => onShowEpisodes(row.id)}>
        {row.episodeCount || 0}
      </button>
    ),
  },
  dateColumn('nextAirDate', 'next airing', { description: 'Madrid time' }),
  dateColumn('updatedAt', 'updated', { sortable: true, description: 'Madrid time' }),
  deleteColumn(onDelete),
];

export const episodeColumns = ({ onEdit, onDelete }) => [
  { field: 'id', headerName: 'id', type: 'string', isId: true, sortable: true, align: 'left' },
  editColumn(onEdit),
  {
    field: 'title', headerName: 'title (es)', type: 'action', align: 'left', content: titleCell,
  },
  {
    field: 'parentTitle',
    headerName: 'program',
    type: 'action',
    align: 'left',
    content: row => multilangLabel(row.parentTitle, row.parentSlug || `#${row.parent} (missing)`),
  },
  { field: 'slug', headerName: 'slug', type: 'string', sortable: true, align: 'left' },
  {
    field: 'status', headerName: 'status', type: 'action', align: 'left', content: row => statusBadge(row.status),
  },
  { field: 'channel', headerName: 'channel', type: 'string', align: 'left' },
  dateColumn('firstAirDate', 'first aired', { sortable: true, description: 'Madrid time' }),
  dateColumn('nextAirDate', 'next airing', { description: 'Madrid time' }),
  dateColumn('updatedAt', 'updated', { sortable: true, description: 'Madrid time' }),
  deleteColumn(onDelete),
];
